import { gql } from '@apollo/client';

export const GET_ORG_INFO = gql`
  query GetOrgInfo {
    orgName
    orgId
    orgDateCreated
    smsEnabled
    isLargeOrg
    tm {
      tenant {
        billing {
          package {
            packageType
            integrations
            insights
            rostering
            bulletins
            incidents
            attendanceBackup
            sms
          }
        }
        menuLabels {
          dashboardHome
          dashboardResources
          dashboardImpact
          volunteeringActivities
          volunteeringActivityReport
          volunteeringIncidentReport
          managementDashboard
          managementActivityManagement
          managementRosters
          managementVolunteers
          managementBulletins
          managementReportManagement
          managementIncidentManagement
          adminTaskManagement
          adminProgramManagement
          adminConsole
          wordActivity
          wordRoster
          wordProgram
        }
        dateDeactivated
        config {
          inTrial
          availabilityRestrictionDays
        }
      }
    }
  }
`;
